import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { SlideMenuService } from '@services/slide-menu.service';

@Component({
  selector: 'app-stories',
  templateUrl: './stories.component.html',
  styleUrls: ['./stories.component.scss'],
  standalone: false,
})
export class StoriesComponent implements OnInit, OnDestroy {
  private slideMenuService = inject(SlideMenuService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  readonly tabOptions = {
    grade_1: '1年',
    grade_2: '2年',
    grade_3: '3年',
    summary: 'まとめ',
  };
  currentTab = 'grade_1';
  private routerSubscriber: Subscription;

  ngOnInit(): void {
    this.routerSubscriber = this.route.queryParams.subscribe((params) => {
      if (Object.keys(this.tabOptions).includes(params['tab'])) {
        this.currentTab = params['tab'];
      } else {
        this.router.navigate(['.'], { queryParams: { tab: this.currentTab }, replaceUrl: true, relativeTo: this.route });
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscriber?.unsubscribe();
  }

  slideMenu() {
    this.slideMenuService.slideIn();
  }
}
